export default "__VITE_ASSET__CQoHQC0v__"